import { render, staticRenderFns } from "./LightText.vue?vue&type=template&id=ca1720aa&scoped=true&"
import script from "./LightText.vue?vue&type=script&lang=js&"
export * from "./LightText.vue?vue&type=script&lang=js&"
import style0 from "./LightText.vue?vue&type=style&index=0&id=ca1720aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1720aa",
  null
  
)

export default component.exports